module.exports = __webpack_public_path__ + "static/media/Nick.cfdf416e.jpg";